export default {"href":"/corgi/pageapps/purchase/_next/public/sprite-3.48.0-de48ae84e.svg#positive","viewBox":"0 0 48 48"}